var _react_refresh_temp_1;
import { jsx as _jsx } from "react/jsx-runtime";
import { Box, Menu } from '@lucidlink/uicore';
import { FilespaceMenuItems } from '../../../menus/FilespaceMenuItems';
export const FilespaceDetailsMenu = ({ closeModal, filespace, }) => {
    return (_jsx(Box, { gap: "s", kind: "level3", orientation: "vertical", padding: "s", radius: "m", children: _jsx(Menu, { navigationType: "arrows", children: _jsx(FilespaceMenuItems, { filespace: filespace, onMenuClick: closeModal }) }) }));
};
_react_refresh_temp_1 = FilespaceDetailsMenu;
$RefreshReg$(_react_refresh_temp_1, "FilespaceDetailsMenu");
